module.exports = __webpack_public_path__ + "static/screenie_icon-25beaea13ed35340665e6cac33da9573.png";